import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {types} from 'main/tools';
import {BenefitClass} from 'main/stores/benefits';
import _ from 'lodash';

class BenefitClassCoveragesState {
  store = new DomainStore();
  match;
  backPath;
  endpoint;

  currentClass;
  currentCoverage;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match, backPath, endpoint}) {
    this.match = match;
    this.backPath = backPath;
    this.endpoint = endpoint;
  }

  async load() {
    await this.store._compose([
      this.endpoint.with(this.match.params.benefitClassId)
    ]);

    this.currentClass = new BenefitClass(
      this.store._getSingle(types.BENEFIT_CLASS)
    );

    this.currentCoverage = _.head(this.currentClass.sortedGroupBenefitCoverages);
  }

  viewCoverage(coverage) {
    this.currentCoverage = coverage;
  }

  get benefitClasses() {
    return [this.currentClass];
  }
}

export default BenefitClassCoveragesState;
